import http from "./http";
const account = {
  getList() {
    return http.get("subject/manage/list");
  },

  getAll() {
    return http.get("subject/common/getAll");
  },

  getInfo(id) {
    return http.get("subject/getInfo/" + id);
  },

  insert(model) {
    return http.post("subject/manage/add", model);
  },

  update(model) {
    return http.post("subject/manage/update", model);
  },

  remove(ids) {
    return http.post("subject/manage/deletes?ids=" + ids, ids);
  },
  //=====================================
  getUsers(type) {
    return http.get("userSubject/manage/list?type=" + type);
  },

  addUser(subjectId, uid, type) {
    return http.post(
      "userSubject/manage/user/add?subjectId=" +
        subjectId +
        "&type=" +
        type +
        "&uid=" +
        uid
    );
  },

  removeUser(subjectId, uid, type) {
    return http.get(
      "userSubject/manage/user/remove?subjectId=" +
        subjectId +
        "&type=" +
        type +
        "&uid=" +
        uid
    );
  },
};
export default account;
